export interface LogisticModeOption {
  value: string;
  label: string;
  description: string;
}

export type SkuSource = 'item_id' | 'gtin';

export interface SkuSourceOption {
  value: SkuSource;
  label: string;
  description: string;
  example: string;
}

export const PLATFORM_NAME = 'MercadoLibreFulfillment';

export const AUTO_CREATE_LOGISTIC_MODES_OPTIONS: LogisticModeOption[] = [
  {
    value: 'me1',
    label: 'Mercado Envíos 1 (Flete Dinámico)',
    description: 'Envíos donde el vendedor gestiona su propia logística o flete acordado.',
  },
  {
    value: 'custom',
    label: 'Personalizado (Custom)',
    description: 'Envíos acordados con el comprador o logística propia del vendedor.',
  },
  {
    value: 'not_specified',
    label: 'No especificado / A convenir',
    description: 'Publicaciones donde el comprador acuerda el envío directamente con el vendedor.',
  },
];

export const SKU_SOURCE_OPTIONS: SkuSourceOption[] = [
  {
    value: 'item_id',
    label: 'ID de Publicación (Por defecto)',
    description: 'Utiliza el ID único de la publicación de Mercado Libre como SKU en Fulfill.',
    example: 'MLM3080506557',
  },
  {
    value: 'gtin',
    label: 'Código Universal / Código de Barras (GTIN/EAN)',
    description: 'Utiliza el código de barras comercial del producto como SKU en Fulfill.',
    example: '7501747619027',
  },
];
